import { useEffect, useState } from 'react';
import { noop } from 'lodash';

import { Button, ButtonProps } from '@mui/material';

import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';

export interface ButtonWithConfirmProps extends ButtonProps {
    confirmationProps: {
        title: string;
        text: string | JSX.Element;
        maxWidth?: string;
    };
    swapPreferredActions?: boolean;
    onOpen?: () => void;
}

const ButtonWithConfirm = ({
    children,
    onClick,
    confirmationProps,
    swapPreferredActions = false,
    onOpen = noop,
    ...rest
}: ButtonWithConfirmProps) => {
    const [confirmVisible, setConfirmVisible] = useState(false);

    useEffect(() => {
        if (confirmVisible) {
            onOpen();
        }
    }, [confirmVisible]);

    return (
        <>
            <Button {...rest} onClick={() => setConfirmVisible(true)}>
                {children}
            </Button>
            {confirmVisible && (
                <ConfirmationDialog
                    onOk={(ev) => {
                        setConfirmVisible(false);
                        onClick?.(ev);
                    }}
                    open={confirmVisible}
                    handleClose={() => {
                        setConfirmVisible(false);
                    }}
                    swapPreferredActions={swapPreferredActions}
                    {...confirmationProps}
                />
            )}
        </>
    );
};

export default ButtonWithConfirm;
